// Currency Configuration for India
export const CURRENCY_CONFIG = {
  symbol: '₹',
  code: 'INR',
  name: 'Indian Rupee',
  locale: 'en-IN',
  decimals: 2
};

/**
 * Format amount in Indian Rupees
 * @param amount - The amount to format
 * @param showSymbol - Whether to show the ₹ symbol (default: true)
 * @returns Formatted currency string
 */
export const formatCurrency = (amount: number, showSymbol: boolean = true): string => {
  if (amount === null || amount === undefined) return showSymbol ? '₹0.00' : '0.00';
  
  const formatted = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: CURRENCY_CONFIG.decimals,
    maximumFractionDigits: CURRENCY_CONFIG.decimals
  }).format(amount);
  
  return formatted;
};

/**
 * Format amount without currency symbol
 */
export const formatAmount = (amount: number): string => {
  if (amount === null || amount === undefined) return '0.00';
  
  return new Intl.NumberFormat('en-IN', {
    minimumFractionDigits: CURRENCY_CONFIG.decimals,
    maximumFractionDigits: CURRENCY_CONFIG.decimals
  }).format(amount);
};

/**
 * Get currency symbol
 */
export const getCurrencySymbol = (): string => {
  return CURRENCY_CONFIG.symbol;
};

/**
 * Parse Indian currency string to number
 */
export const parseCurrency = (value: string): number => {
  // Remove currency symbol, commas, and spaces
  const cleaned = value.replace(/[₹,\s]/g, '');
  return parseFloat(cleaned) || 0;
};

